module.exports = __webpack_public_path__ + "img/26_insee1994.0ed85fa2.jpg";